import getPathToRedirectLoggedInUser from '@/mixins/getPathToRedirectLoggedInUser'
import store from '@/store'

export default async (to, from, next) => {
  switch (true) {
    case Boolean(store.getters['auth/isAuthenticated']()):
      try {
        next(await getPathToRedirectLoggedInUser())
        break
      } catch (error) {
        next()
        break
      }

    default:
      next()
      break
  }
}
